import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SessionStorageService} from '../shared/services/session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationInterceptor implements HttpInterceptor {
  constructor(private sessionStorageService: SessionStorageService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${this.sessionStorageService.getUserToken()}`,
        'X-TFA': `Bearer ${this.sessionStorageService.getTwoFactorAuthenticationToken()}`
      }
    });
    return next.handle(request);
  }
}
